module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/PY-401a046d5e381e9b028079a900ebb032.png";